<template>
<div class="bytee-quiz">
  <h3>Imprint & Legal information</h3>
  <p>This website is owned and operated by:</p>
  <p>Valentin - Andrei Despa</p>
  <p>Address: Luisenstr. 4, 55583 Bad Kreuznach, RP, Germany</p>
  <p>Email: valentin at vdespa.com</p>
</div>
</template>

<script>

export default {
  name: 'resources',
  components: {},
};
</script>

<style>
</style>
